import _ from 'lodash'

// eslint-disable-next-line import/no-cycle -- Dependency cycle detected.
import {createStringMatcher} from './DataTools'

export default class ObjectDataTools {
  data: any | undefined | null

  constructor(data?: any | null) {
    this.data = data
  }

  *iterator(skipEmpty?: boolean): IterableIterator<[number | string, any]> {
    if (Array.isArray(this.data)) {
      let key = 0
      for (const value of this.data) {
        if (skipEmpty || value !== undefined) yield [key, value]
        ++key
      }
    } else if (this.data && typeof this.data === 'object') {
      for (const key of Object.keys(this.data)) {
        const value = this.data[key]
        if (skipEmpty || value !== undefined) yield [key, value]
      }
    }
  }

  slice(begin?: number, end?: number): Array<any> {
    if (Array.isArray(this.data)) {
      return this.data.slice(begin, end)
    }
    return _.values(this.data).slice(begin, end)
  }

  get(key: string | number): any {
    if (!this.data) {
      return undefined
    }
    return this.data[key]
  }

  getId(key: string | number) {
    return (this.data && (this.data.id || this.data.$id)) || key
  }

  toPlain() {
    return this.data
  }

  createObjectMatcher(matchTo: any): (item: any) => boolean {
    return _.matches(matchTo)
  }

  createStringMatcher(matchTo: string): (item: any) => boolean {
    return createStringMatcher(matchTo)
  }

  createMatcher(matchTo: any | string | Function): (item: any) => boolean {
    if (typeof matchTo === 'object') {
      return this.createObjectMatcher(matchTo)
    } else if (typeof matchTo === 'function') {
      return matchTo
    }
    return this.createStringMatcher(String(matchTo))
  }
}
